import React from 'react'

const ComingSoon = ({ title = 'Coming Soon', subtitle = 'This feature is under development' }) => {
  return (
    <div className='flex flex-col items-center justify-center min-h-[400px] px-4 py-8'>
      <div className='text-center max-w-md'>
        <svg
          className='w-16 h-16 md:w-20 md:h-20 mx-auto mb-4 text-gray-400'
          fill='none'
          stroke='currentColor'
          viewBox='0 0 24 24'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.5}
            d='M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'
          />
        </svg>
        <h2 className='text-2xl md:text-3xl font-semibold text-gray-800 mb-2'>
          {title}
        </h2>
        <p className='text-sm md:text-base text-gray-600'>
          {subtitle}
        </p>
      </div>
    </div>
  )
}

export default ComingSoon